export async function copyToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return true
  }
  if (!navigator.clipboard.writeText) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    return true;
  }
  return false
}